import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MedReviewService } from '../../services/med-review.service';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';

@Component({
  selector: 'kt-pend-problem',
  templateUrl: './pend-problem.component.html',
})
export class PendProblemComponent implements OnInit {
  laterForm: FormGroup;
  duration = 0;
  durationCtrl = new FormControl();
  reasons = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PendProblemComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private medReviewService: MedReviewService,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  ngOnInit(): void {
    this.medReviewService.getReasonsSelect().subscribe((res) => {
      this.reasons = res;
    });
    this.laterForm = this.fb.group({
      reason: [undefined, Validators.required],
      note: [undefined, Validators.required],
    });
  }

  close() {
    this.dialogRef.close({ refresh: true });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.laterForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  save() {
    const controls = this.laterForm.controls;
    if (this.laterForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    const d = new Date();
    // tslint:disable-next-line:radix
    d.setMonth(d.getMonth() + parseInt(this.durationCtrl.value));
    const body = {
      reason: this.laterForm.controls.reason.value,
      note: this.laterForm.controls.note.value,
      due_date: null,
    };
    if (this.data.from === 'later_date') {
      body.due_date = this.datePipe.transform(d, 'yyyy-MM-dd');
    }
    if (this.data.from === 'ignore') {
      // tslint:disable-next-line:no-shadowed-variable
      const d = new Date();
      body.due_date = this.datePipe.transform(
        new Date(d.getFullYear() + 99, d.getMonth(), d.getDate()),
        'yyyy-MM-dd',
      );
    }
    this.medReviewService
      .pendOrIgnoreDRP(body, this.data.patient.id, this.data.drp.id)
      .subscribe(() => {
        if (this.data.from === 'ignore') {
          this.layoutUtilsService.showActionNotification(
            'DRP Ignored Successfully',
            MessageType.Update,
            3000,
            false,
            false,
          );
          this.dialogRef.close({ refresh: true });
          return;
        }
        this.layoutUtilsService.showActionNotification(
          'DRP Pended Successfully',
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.dialogRef.close({ refresh: true });
      });
  }

  getTitle() {
    if (this.data.from === 'later_date') return 'Set DRP Review Date';
    if (this.data.from === 'ignore') return 'Ignore DRP';
  }
}
